module.exports = __webpack_public_path__ + "img/1.53ef3242.png";